<div class="wrapper-login-container">
  <div class="wrapper-container-login">
    <div class="row">
      <div class="col-md-12">
        <img
          src="../../assets/images/logo.png"
          alt="logo"
          class="logo-header-login"
        />
        <!-- <h2>Login</h2> -->
        <!-- <h2 >Forgot Password</h2> -->
        <form [formGroup]="loginForm" class="login-form">
          <div class="form-group" *ngIf="!isOtpRequired">
            <label for="username">Username</label>
            <input
              type="text"
              autocomplete="off"
              class="form-control"
              id="username"
              formControlName="userName"
              name="username"
            />
          </div>
          <div class="form-group" *ngIf="forgotPassword && !isOtpRequired">
            <div class="example-container">
              <label for="password">Password</label>
              <div class="password-input-container">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  autocomplete="off"
                  class="form-control"
                  id="password"
                  formControlName="password"
                  name="password"
                />
                <span
                  class="password-toggle-icon"
                  (click)="showPassword = !showPassword"
                >
                  <mat-icon>{{
                    showPassword ? "visibility" : "visibility_off"
                  }}</mat-icon>
                </span>
              </div>
            </div>
          </div>
          <!-- NEW PASSWORD -->
          <div class="form-group" *ngIf="!forgotPassword && !isOtpRequired">
            <label>New Password</label>
            <input
              [type]="showPassword ? 'text' : 'password'"
              class="form-control"
              formControlName="newPassword"
            />
            <!-- <span
              class="password-toggle-icon1"
              (click)="showPassword = !showPassword"
            >
              <mat-icon>{{
                showPassword ? "visibility" : "visibility_off"
              }}</mat-icon>
            </span> -->

            <!-- password required -->
            <small
              class="text-danger"
              *ngIf="
                loginForm.get('newPassword')?.touched &&
                loginForm.get('newPassword')?.hasError('required')
              "
            >
              New password is required
            </small>

            <!-- password minimum length -->
            <small
              class="text-danger"
              *ngIf="
                loginForm.get('newPassword')?.touched &&
                loginForm.get('newPassword')?.hasError('minlength')
              "
            >
              Password must be at least 6 characters
            </small>
          </div>

          <!-- CONFIRM PASSWORD -->
          <div class="form-group" *ngIf="!forgotPassword && !isOtpRequired">
            <label>Confirm Password</label>
            <input
              [type]="showPassword ? 'text' : 'password'"
              class="form-control"
              formControlName="confirmPassword"
            />
            <span
              class="password-toggle-icon2"
              (click)="showPassword = !showPassword"
            >
              <mat-icon>{{
                showPassword ? "visibility" : "visibility_off"
              }}</mat-icon>
            </span>
            <small
              class="text-danger missmatch"
              *ngIf="
                loginForm.hasError('passwordMismatch') &&
                loginForm.get('confirmPassword')?.touched
              "
              >Password do not match
            </small>

            <!-- confirm required -->
            <!-- <small
              class="text-danger"
              *ngIf="
                loginForm.get('confirmPassword')?.touched &&
                loginForm.get('confirmPassword')?.hasError('required')
              "
            >
              Confirm password is required
            </small> -->

            <!-- passwords do not match -->
          </div>

          <div class="form-group" *ngIf="isOtpRequired && !sentOtp">
            <label class="otp-label">Enter 6-digit OTP </label>

            <div class="otp-wrapper">
              <input
                *ngFor="let ctrl of otpControls; let i = index"
                type="text"
                maxlength="1"
                class="otp-box"
                (input)="onInput($event, i)"
                (keydown)="onKeyDown($event, i)"
                (paste)="onPaste($event)"
                #otpBox
              />
            </div>
          </div>
          <div class="form-group" *ngIf="sentOtp">
            <label class="otp-label">Enter 6-digit OTP </label>

            <div class="otp-wrapper">
              <input
                *ngFor="let ctrl of otpControls; let i = index"
                type="text"
                maxlength="1"
                class="otp-box"
                (input)="onInput($event, i)"
                (keydown)="onKeyDown($event, i)"
                (paste)="onPaste($event)"
                #otpBox
              />
            </div>
          </div>

          <br />
          <div class="text-right" *ngIf="forgotPassword && !isOtpRequired">
            <a class="forgotPassword" (click)="onForgotClick()">
              Forgot Password?
            </a>
          </div>
          <div class="text-right" *ngIf="!forgotPassword && !isOtpRequired">
            <a class="forgotPassword" (click)="onForgotClick()"> Login </a>
          </div>

          <button
            type="submit"
            class="btn btn-lg btn-primary btn-login d-flex align-items-center justify-content-center"
            [disabled]="
              loginForm.get('userName')?.invalid ||
              loginForm.get('password')?.invalid
            "
            *ngIf="!isOtpRequired && forgotPassword"
            (click)="onLogin()"
          >
            <mat-spinner *ngIf="isSubmitting" diameter="24" class="white-spinner"></mat-spinner>
            {{ isSubmitting ? "Logging in..." : "Login" }}
          </button>
          <button
            class="btn btn-lg btn-primary btn-login"
            (click)="onSubmit()"
            *ngIf="isOtpRequired && !sentOtp"
          >
            Verify OTP
          </button>
          <button
            class="btn btn-lg btn-primary btn-login"
            *ngIf="!forgotPassword && !isOtpRequired"
            (click)="sendOtpClick()"
            [disabled]="
              loginForm.get('newPassword')?.invalid ||
              loginForm.get('confirmPassword')?.invalid
            "
          >
            Send OTP
          </button>
          <button
            class="btn btn-lg btn-primary btn-login"
            *ngIf="sentOtp"
            (click)="newPasswordClick()"
          >
            Verify OTP
          </button>
        </form>
      </div>
    </div>
    <br />
    <!-- <div class="text-center" *ngIf="forgotPassword">
        New User?
        <a class="forgotPassword" (click)="onRegistrationClick()"> Register </a>
      </div> -->
  </div>
</div>
